import { render } from "./SearchResultWrapper.vue?vue&type=template&id=21026b4b"
import script from "./SearchResultWrapper.vue?vue&type=script&lang=js"
export * from "./SearchResultWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/brekz-prestashop/brekz-prestashop/web/themes/brekz-2017/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__